import * as React from 'react';
import {withRouter} from 'react-router';
import Col from 'reactstrap/lib/Col';
import Switch from 'react-switch';
import {IHistory} from '../../interfaces';
import {UserModel} from '../../model/UserModel';
import {Icon} from '../reusableComponents/Icon';
import {DeleteUserDialog} from './DeleteUserDialog';
import {getCurrentUserUUID, addZero} from '../../utils/generalUtils';
import {getUserData} from '../../services/utilityServices';

export interface IListItemProps {
    instance?: UserModel;
    index?: number;
    listItemProp?: string;
    onClick?: Function;
    className?: string;
    history?: IHistory;
}

interface IListItemState {
    open: boolean;
    isUserActive: boolean;
    oldUserStatus: boolean;
}

export class ListItemImpl extends React.Component<IListItemProps, IListItemState> {
    constructor(props: IListItemProps) {
        super(props);
        this.state = {open: false, isUserActive: props.instance.props.Active, oldUserStatus: props.instance.props.Active};
        this.userActiveSwitchChange = this.userActiveSwitchChange.bind(this);
    }

    userActiveSwitchChange = (status, isWindowToOpen?: boolean) => {
        this.setState({
            isUserActive: status
        }, () => {
            this.setState({
                open: isWindowToOpen
            });
        });
    }

    public render() {
        const {history, instance} = this.props;
        const isSameLevel = getUserData().accessLevel === instance.props.AccessLevel;
        return <div className="list-item">
            <DeleteUserDialog
                history={this.props.history}
                onClose={() => this.userActiveSwitchChange(this.state.oldUserStatus, false)}
                open={this.state.open}
                userStatus={this.state.isUserActive}
                instance={instance}/>
            <Col
                onClick={() => history.push(`/users/${instance.props.id}`)}
                className="serial-no" sm={1}>
                <div className="center" style={{width: '100%'}}>{instance ? addZero(instance.props.Id) : ''}</div>
            </Col>
            <Col onClick={() => history.push(`/users/${instance.props.id}`)} className="name" sm={3}>
                {instance.props.FirstName}
            </Col>
            <Col onClick={() => history.push(`/users/${instance.props.id}`)} className="access_level" sm={2}>
                {instance.props.Access_Level || 'L1'}
            </Col>
            <Col onClick={() => history.push(`/users/${instance.props.id}`)} className="job_title" sm={2}>
                {instance.props.JobTitle}
            </Col>
            <Col onClick={() => history.push(`/users/${instance.props.id}`)} className="date_created" sm={2}>
                {instance.props.DateCreated || 'NA'}
            </Col>
            <div className="mobile-container col-sm-2">
                <Col
                    className="trash" sm={6}>
                    <Switch disabled={isSameLevel} className='user-switch' onChange={(e) => this.userActiveSwitchChange(e, true)} checked={instance.props.Active}/>
                </Col>
                {!isSameLevel ? <Col
                    onClick={() => history.push(`/users/edit/${instance.props.id}`)}
                    className="edit user-edit"
                    sm={3}>
                    <Icon icon="pencil-alt"/>
                </Col> : <Col className="edit user-edit" sm={3}> <Icon icon="fa-stack"/> </Col>}
            </div>
        </div>;
    }
}

export const ListItem = withRouter(ListItemImpl as any);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Users/ListItems.tsx